import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class Snackbar {

    constructor(private readonly snackbar: MatSnackBar) { }

    public openSnackBar(message: string, action?: string, isError?: boolean) {
        this.snackbar.open(message, action, {
            duration: 3000,
            panelClass: [
                isError ? 'snackbar-error' : 'snackbar-success',
            ]
        });
    }
}
